<template>
  <div class="choiceSuccess main-panel">
    <div class="main main-step-paysuccess">
      <z-steps :step="3" style="background:#fafafa;"></z-steps>
      <div class="detail" v-if="![4,5].includes(type)">
         <div class="leftMsg">
          <div class="title-top">付款成功</div>
          <div class="title">
            <span class="orderType">
              支付内容：
              <span v-if="orderDetail.paymentStage">{{orderDetail.paymentStage}}</span>
              <span v-else>{{orderDetail.subject}}</span>
              <span v-if="orderDetail.paymentStagePercent">（{{orderDetail.paymentStagePercent}}%）</span>
            </span>
          </div>
          <div class="orderNum">
            订单号：
            <span>{{orderDetail.orderCode || orderDetail.code}}</span>
          </div>
          <div class="shouldPay">
            应付：
            <span>{{orderDetail.amountDisplay || orderDetail.amount | currency('¥','2')}}</span>
          </div>
        </div>
      </div>
      <div class="showMsg">
        <i class="iconfont icon-wancheng"></i>
        <p>{{type==5?'充值':'支付'}}成功，感谢您的支持！</p>
        <!-- <p class="router-text">住逻辑将在1～3日内为您确认付款，请您耐心等待</p> -->
        <p v-if="[4,5].includes(type)" class="router-text">
          <span class="red-font">{{timer}} 秒</span>后跳转
        </p>
        <div class="rightButton">
          <div class="hetong" v-if="type === 'orderStage'">
            <p>合同信息：</p>
            <i class="iconfont icon-hetong"></i>
            <span v-if="getSignedData && !downLoading" @click="faileDownHandle(getSignedData)">下载合同</span>
            <span v-if="getSignedData && downLoading">合同下载中...</span>
            <span class="specail" v-if="!getSignedData && downLoading">合同生成失败请联系客服</span>
          </div>
          <!-- <router-link class="other" to="/">继续逛逛 ></router-link> -->
          <a :href="nuxtUrl" class="other">继续逛逛 ></a>

          <br />
          <!--<a v-if="orderId" class="button" :class="type !== 'orderStage' ? 'specail-button': ''" :href=" type !== 'orderStage' ? '/my/personal/eggPurchase/eggbuy' : '/my/order/detail/' + orderId">查看订单</a>-->
          <a
            v-if="type === 'points' && orderId"
            class="button"
            :class="type !== 'orderStage' ? 'specail-button': ''"
            :href="VUE_APP_NEXT_BASIC_URL+'/my-egg'"
          >我的恐龙蛋</a>
          <a
            v-if="type === 'member' && orderId"
            class="button"
            :class="type !== 'orderStage' ? 'specail-button': ''"
            :href="VUE_APP_OLD_BASIC_URL+'/my/personal/vip'"
          >查看会员</a>
          <a
            v-if="orderId && (type === 'orderStage' || type === 'orderExtra')"
            class="button"
            :class="type !== 'orderStage' ? 'specail-button': ''"
            :href="VUE_APP_NEXT_BASIC_URL + '/details/' + orderDetail.orderId"
          >查看订单</a>
        </div>
      </div>
      <file-download ref="fileDownload"></file-download>
    </div>
  </div>
</template>

<script>
const VUE_APP_NEXT_BASIC_URL = process.env.VUE_APP_NEXT_BASIC_URL;
import searchBox from "../../../common/searchBox.vue";
import fileDownload from "../../../common/fileDownload.vue";
import loading from "../../../common/loading.vue";
import api from "../../../../api";
import config from "../../../../config/config";
import Pay from "../../../../mixins/pay";
export default {
  mixins: [Pay],
  data() {
    return {
      VUE_APP_NEXT_BASIC_URL: VUE_APP_NEXT_BASIC_URL,
      nuxtUrl: process.env.VUE_APP_NUXT_BASIC_URL,
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      orderDetail: "",
      orderId: undefined,
      type: undefined,
      timer: 5,
      getSignedData: null,
      loading: false,
      isZhulogic: config.isZhulogic,
      downLoading: false
    };
  },
  berforRouteEnter(to, from, vm) {
    api.pay.signed_contract(to.params.id).then(res => {
      next(vm => {
        if (res) {
          vm.getSignedData = res;
        } else {
          window.setTimeout(function() {
            api.pay.signed_contract(vm.orderId).then(re => {
              vm.getSignedData = re;
            });
          }, 3000);
        }
      });
    });
  },
  methods: {
    getPayInfo() {
      const payChannel = this.$route.query.payChannel || "";
      const dataParams = {
        id: this.orderId,
        type: this.type,
        payChannel: payChannel,
        chargeId: this.$route.query.chargeId || "",
        orderNo:this.$route.query.orderNo
      };
      api.pay.payCheck(dataParams).then(res => {
        this.orderDetail = res;
      });
    },
    goBack() {
      if (this.type === 5) {
        this.$router.push({ name: "myEggPurchase" });
      } else {
        api.points.getFirstVip().then(res => {
          this.$router.push({
            name: "myVip",
            query: { showUpgrade: res ? 1 : 0 }
          });
        });
      }
    },
    getSigned() {
      let that = this;
      api.pay.signed_contract(this.orderId).then(res => {
        if (res) {
          this.getSignedData = res;
        } else {
          window.setTimeout(function() {
            api.pay.signed_contract(that.orderId).then(re => {
              this.getSignedData = re;
            });
          }, 3000);
        }
      });
    },
    faileDownHandle(files) {
      this.downLoading = true;
      if (!files) {
        this.$Message.error("暂无文件可下载！");
      } else {
        api.files
          .downloadFile(files.contractFile.id)
          .then(state => {
            if (state != "success") {
              this.$Message.error("下载失败,文件 key 错误");
            }
            this.downLoading = false;
          })
          .catch(() => {
            this.downLoading = false;
          });
      }
    }
  },
  components: {
    searchBox,
    fileDownload,
    loading
  },
  created() {
    this.orderId = this.$route.params.id;
    this.type = this.$route.params.type;
    if ([4, 5].includes(this.type)) {
      let interval = setInterval(() => {
        this.timer--;
        if (this.timer < 1) {
          clearInterval(interval);
          this.goBack();
        }
      }, 1000);
    } else {
      this.getPayInfo();
    }
    if (this.type === "orderStage") {
      this.getSigned();
    }
  }
};
</script>

<style scoped>
.choiceSuccess {
  padding: 30px 0 10px;
}
.choiceSuccess .main {
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 0;
  /* padding: 40px; */
}
.choiceSuccess .main .showMsg {
  /* height: 331px; */
  padding-bottom: 80px;
  text-align: center;
  background: #fff;
}
.choiceSuccess .main .showMsg i {
  display: inline-block;
  color: rgba(147, 219, 69, 0.9);
  font-size: 60px;
  margin-top: 60px;
}
.choiceSuccess .main .showMsg p {
  font-size: 22px;
  color: #15161b;
  margin-top: 10px;
}
.choiceSuccess .main .detail {
  width: 100%;
  min-height: 193px;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom:30px;
}
.choiceSuccess .main .detail:after {
  content: "";
  display: block;
  clear: both;
}
.choiceSuccess .main .detail .leftMsg {
  float: left;
  width: 100%;
}
.choiceSuccess .main .detail .leftMsg .title-top {
  font-size: 18px;
  font-weight: 500;
  color: #313131;
  border-bottom: 1px solid #e7e7e7;
  width: 100%;
  margin-bottom: 20px;
  padding: 10px 0;
}
.choiceSuccess .main .detail .leftMsg .title {
  font-size: 16px;
  color: #707070;
  width: 100%;
  padding-left: 20px;
}
.choiceSuccess .main .detail .leftMsg .title .orderType {
  color: #707070;
}
.choiceSuccess .main .detail .leftMsg .title .orderType span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .orderNum {
  font-size: 16px;
  color: #707070;
  margin-top: 10px;
  padding-left: 20px;
}
.choiceSuccess .main .detail .leftMsg .orderNum span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .paynNum {
  font-size: 14px;
  color: #353838;
  margin-top: 4px;
}
.choiceSuccess .main .detail .leftMsg .shouldPay {
  font-size: 16px;
  color: #707070;
  padding-left: 20px;
  margin-top: 8px;
}
.choiceSuccess .main .detail .leftMsg .shouldPay span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .shouldPay span {
  font-size: 16px;
  color: #e14b5d;
}
.choiceSuccess .main .detail .leftMsg .Paid {
  font-size: 14px;
  color: #353838;
  margin-top: 4px;
}
.choiceSuccess .main .detail .leftMsg .Paid > span {
  color: #e14b5d;
}
.choiceSuccess .main .rightButton {
  position: relative;
}
.choiceSuccess .main .rightButton .hetong {
  float: right;
  margin-top: 127px;
  margin-right: 30px;
}
.choiceSuccess .main .rightButton .hetong p {
  font-size: 12px;
  color: #6c6f70;
}
.choiceSuccess .main .rightButton .hetong span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353838;
  letter-spacing: 0;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 10px;
}
.choiceSuccess .main .rightButton .hetong span.specail {
  color: #6c6f70;
  text-decoration: none;
  cursor: default;
}
.choiceSuccess .main .rightButton .hetong span:hover {
  color: #6c6f70;
}
.choiceSuccess .main .rightButton .hetong i {
  font-size: 15px;
  color: #e14b5d;
  margin-top: 10px;
}
.choiceSuccess .main .rightButton .other {
  position: absolute;
  left: 690px;
  display: inline-block;
  font-size: 14px;
  color: #6c6f70;
  margin-top: 100px;
  text-decoration: underline;
}
.choiceSuccess .main .rightButton .button {
  display: inline-block;
  width: 145px;
  height: 40px;
  margin-top: 70px;
  text-align: center;
  line-height: 40px;
  background: #e56a69;
  border-radius: 4x;
  font-size: 14px;
  color: #ffffff;
}
.choiceSuccess .main .rightButton .specail-button {
  margin-top: 75px;
}
.choiceSuccess .main .showMsg p.router-text {
  font-size: 16px;
  color: #171a1a;
  letter-spacing: 2.4px;
}
.choiceSuccess .main .showMsg p.router-text .red-font {
  font-size: 16px;
}
</style>

<style lang="scss">
.main-step-paysuccess {
  margin-top: -10px;
  .zSteps-common .col-span {
    background: #313131;
  }
  .zSteps-line .line {
    width: 0px !important;
  }
}
</style>